<template>
  <v-row
    class="base-layout no-gutters"
  >
    <StHeader
      @side-icon-clicked="toggleDrawer"
    >
      <template #right>
        <StUserMenu
          :user="user"
          :greeting="$t('Layout.greeting')"
          :logout-label="$t('Layout.logout')"
          class="pr-4"
          @logout-item-clicked="logoutAndSendUserToLoginPage"
        />
      </template>
    </StHeader>

    <v-content
      class="content-white"
    >
      <v-row class="no-gutters fill-height">
        <LayoutContent />

        <StSystemNavigationDrawer
          :drawer="drawer"
          :items="itemsInDrawer"
          :active-url="itemActive"
        />
      </v-row>
    </v-content>
  </v-row>
</template>

<script>
import StHeader from '@stilingue/st-header';
import StUserMenu from '@stilingue/st-user-menu';
import StSystemNavigationDrawer from '@stilingue/st-system-navigation-drawer';
import LayoutContent from '@/components/LayoutContent';
import { checkForAuthentication, logoutAndSendUserToLoginPage } from '@stilingue/st-auth-utils';
import { mapMutations, mapState } from 'vuex';
import { MUTATE } from '@/store/modules/mutation_types';
import store from '@/store/store';
import { insertLogRocketMetadata } from '@/plugins/logrocket';
import { insertAnalyticsMetadata } from '@/plugins/analytics';
import { insertSentryMetadata } from '@/plugins/sentry';
import { insertRolloutMetadata } from '@/plugins/rollout';

export default {
  name: 'Home',
  components: {
    StSystemNavigationDrawer,
    StHeader,
    StUserMenu,
    LayoutContent
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const authenticated = checkForAuthentication();
      let user;
      if (authenticated) {
        user = await store.dispatch('user/getUserMe');
        if (user) {
          console.info('User found', user);
          insertLogRocketMetadata({
            email: user.email,
            name: user.name,
            id: user.id,
          });
          insertAnalyticsMetadata({
            user_email: user.email,
            user_name: user.name,
            user_id: user.id,
          });
          insertSentryMetadata({
            username: user.name,
            email: user.email,
            id: user.id,
          });
          insertRolloutMetadata({
            user_email: user.email,
            user_name: user.name,
            user_id: user.id,
          });
          await store.dispatch('user/getFirebaseUser', user);
          return next();
        }
      }

      return next({
        name: 'login',
      });
    } catch (e) {
      console.error(e);
      return next({
        name: 'error',
        params: {
          errorStatus: '500'
        }
      });
    }
  },
  data() {
    return {
      itemActive: 'https://tickets.stilingue.com.br',
      itemsInDrawer: [
        {
          name: this.$t('StSystemNavigationDrawer.tickets'),
          link: 'https://tickets.stilingue.com.br'
        },
        {
          name: this.$t('StSystemNavigationDrawer.permissions'),
          link: 'https://permissoes.stilingue.com.br'
        },
        {
          name: this.$t('StSystemNavigationDrawer.warroom'),
          link: 'https://warroom.stilingue.com.br'
        },
        {
          name: this.$t('StSystemNavigationDrawer.sac'),
          link: 'https://warroom.stilingue.com.br/conversas'
        },
        {
          name: this.$t('StSystemNavigationDrawer.performance'),
          link: 'https://warroom.stilingue.com.br/metricas-proprietarias'
        }
      ]
    };
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('misc', ['drawer']),
    companyId() {
      return String(this.activeCompany.id);
    }
  },
  methods: {
    logoutAndSendUserToLoginPage,
    ...mapMutations('misc', {
      mutateMisc: MUTATE
    }),
    toggleDrawer() {
      this.mutateMisc({
        property: 'drawer',
        with: !this.drawer
      });
    },
    ...mapMutations('company', {
      mutateCompany: 'MUTATE'
    }),
    updateCompany(company) {
      this.mutateCompany({
        property: 'activeCompany',
        with: company
      });
    }
  }
};
</script>

<style scoped lang="scss">
  .base-layout {
    background: white;
  }
</style>
